import { isEmpty, get, orderBy } from 'lodash'
import { defaultListener } from "../helper"

export default {
  state: {
    tasks: {},
    filters: {
      isOpen: false,
      keyword: '',
      groups: []
    }
  },
  mutations: {
    resetTasks(state) {
      state.tasks = {}
    },
    patchTaskFilter(state, filter) {
      state.filters = {
        ...state.filters,
        ...filter
      }
    },
    addTask(state, task) {
      const { id } = task

      if (id) {
        const newState = { ...state.tasks }
        newState[ id ] = task
        state.tasks = newState
      }
    },
    removeTask(state, id) {
      if (state.tasks[ id ]) {
        const newState = { ...state.tasks }
        delete newState[ id ]
        state.tasks = newState
      }
    }
  },
  getters: {
    getTaskFilters(state) {
      return state.filters
    },
    taskPool: (state, getters) => {
      let tasks = [ ...getters.filteredTasks ]
      tasks = tasks.filter(task => isEmpty(task.claimedBy))

      return orderBy(tasks, task => get(task, 'createdAt.seconds', 0), 'desc')
    },
    myTasks: (state, getters) => {
      let tasks = [ ...getters.filteredTasks ]
      tasks = tasks.filter(task => task.claimedBy === getters.getUID)

      return orderBy(tasks, task => get(task, 'createdAt.seconds', 0), 'desc')
    },
    filteredTasks(state) {
      let tasks = Object.values(state.tasks)
      const isKeywordFilterEmpty = isEmpty(state.filters.keyword)
      const isGroupsFilterEmpty = isEmpty(state.filters.groups)

      if (!isKeywordFilterEmpty) {
        const { keyword } = state.filters
        tasks = tasks.filter(task => {
          // We want the search to be case-insensitive
          return task.label.search(new RegExp(keyword, 'i')) !== -1
            || task.description.search(new RegExp(keyword, 'i')) !== -1
        })
      }

      if (!isGroupsFilterEmpty) {
        const { groups } = state.filters
        tasks = tasks.filter(task => task.groups.some(g => groups.includes(g)))
      }

      return tasks
    },
    incompleteTasks(state) {
      return Object.values(state.tasks).filter(n => n.isComplete === false)
    },
    historicTasks(state) {
      return Object.values(state.tasks).filter(n => n.isComplete === true)
    }
  },
  actions: {
    claimTask({ getters, commit }, id) {
      const merge = true
      const sessionTenant = getters.getSessionTenant
      const payload = {
        claimedBy: getters.getUID,
        claimedAt: new Date()
      }

      this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('tasks')
        .doc(id)
        .set(payload, { merge })
        .catch(e => commit('showSnack', { text: e, color: 'error' }))
    },
    initTasks({ commit, getters }) {
      // was the reset here because of the app initialization issue from before?
      // commit('resetTasks')
      const sessionTenant = getters.getSessionTenant

      // Listeners for each group
      const userGroups = getters.getUserGroups

      console.log('User groups', userGroups)

      userGroups.forEach(groupId => {
        this.$firebase.firestore()
          .collection('tenants')
          .doc(sessionTenant)
          .collection('tasks')
          .where('groups', 'array-contains', groupId)
          .where('isComplete', '==', false)
          .onSnapshot(
            defaultListener.bind(this, commit, 'addTask', 'removeTask'),
            e => console.log(e)
          )
      })

      // Listeners for the logged in user & their claimed tasks
      const uid = getters.getUID

      if (uid) {
        this.$firebase.firestore()
          .collection('tenants')
          .doc(sessionTenant)
          .collection('tasks')
          .where('uids', 'array-contains', uid)
          .where('isComplete', '==', false)
          .onSnapshot(
            defaultListener.bind(this, commit, 'addTask', 'removeTask'),
            e => console.log(e)
          )

        // Listeners for claimed tasks
        this.$firebase.firestore()
          .collection('tenants')
          .doc(sessionTenant)
          .collection('tasks')
          .where('claimedBy', '==', uid)
          .where('isComplete', '==', false)
          .onSnapshot(
            defaultListener.bind(this, commit, 'addTask', 'removeTask'),
            e => console.log(e)
          )
      }
    },
    completeTask({ getters, commit }, id) {
      const merge = true
      const sessionTenant = getters.getSessionTenant
      const payload = {
        completedBy: getters.getUID,
        completedAt: new Date(),
        isComplete: true
      }

      /**
       * We have to manually remove the task here because
       * our query listener is only listening to tasks where
       * isComplete === false. So once we update the value,
       * it is no longer part of that query so it is no longer being observed
       */
      this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('tasks')
        .doc(id)
        .set(payload, { merge })
        .then(() => commit('removeTask', id))
        .catch(e => console.log(e))
    }
  }
}
